import { Column, Columns } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';
import { CSSProperties } from 'react';
import { useLocation } from 'react-router-dom';

import { Menu } from 'components/settings/components/menu';
import { useBreakpointValue } from 'utils/mediaQuery';

/** Represents the settings view. */
export const SettingsView = ({ children }: PropsWithChildren): JSX.Element => {
  const location = useLocation();
  const isSmallScreen = useBreakpointValue({ base: true, md: false });

  const showSettingsMenu = !/\/flow\/(?!.*history)/g.test(location.pathname);

  return (
    <Columns>
      {showSettingsMenu && (
        <Column size={isSmallScreen ? menuWidths[0] : menuWidths[1]}>
          <Column.Row
            scrollable
            noHorizontalPadding
            noVerticalPadding
            style={
              {
                '--menu-width-collapsed': menuWidths[0],
                '--menu-width-expanded': menuWidths[1],
              } as CSSProperties
            }
          >
            <Menu />
          </Column.Row>
        </Column>
      )}

      <Column size="3fr">{children}</Column>
    </Columns>
  );
};

const menuWidths = ['68px', '258px'];
